// extracted by mini-css-extract-plugin
export default {"-large":"fuASm6Nw776Ey7wCgtKO","failedMessage":"Ykha_2iPA1xpo7yayKsF"};